import { useQuery } from '@tanstack/react-query';
import { useParams } from '@tanstack/react-router';
import { pcmpMisBatchReportQueryOptions } from '../api/pcmpMis.api';
import { PcmpBatchPrintView } from '../components/PcmpBatchReport/PcmpBatchPrintView';

export function PcmpMisBatchPrintPage() {
  const { batchNo } = useParams({ from: '/_print/pcmp/mis/batches/$batchNo/print' });
  const { data, isLoading, isFetching, error, refetch } = useQuery({
    ...pcmpMisBatchReportQueryOptions(batchNo),
    // Closing the print dialog refocuses the tab; keep the sheet as printed.
    refetchOnWindowFocus: false,
  });

  return (
    <PcmpBatchPrintView
      batchNo={batchNo}
      report={data}
      isLoading={isLoading}
      isFetching={isFetching}
      error={error}
      refetch={() => void refetch()}
      documentTitle={`CMP Disbursement Batch ${batchNo}`}
    />
  );
}
